import { createAsyncThunk } from '@reduxjs/toolkit';

import { ProjectsService } from 'api';

import { PaginationParams } from 'models';

export const getPrimaryMarketItems = createAsyncThunk(
	'primaryMarket/getPrimaryMarketItems',
	async (params?: PaginationParams) => {
		return await ProjectsService.getAll(params);
	},
);
